/**
 * The admin password policy, mirrored from the gateway (service/password_policy.go, the
 * authority) for instant feedback: at least 12 characters with 3 of the 4 kinds (uppercase,
 * lowercase, number, symbol), not containing the email's name part or "veoride". Balanced on
 * purpose: length does most of the work, so all four kinds are not required.
 */
export const MIN_PASSWORD = 12;

const KINDS = [/\p{Lu}/u, /\p{Ll}/u, /\p{Nd}/u, /[\p{P}\p{S}]/u];

export type PasswordProblem = 'weak' | 'emailName' | 'veoride';

/** The first rule `password` breaks for an account with `email`, or null when it is acceptable. */
export function passwordProblem(password: string, email?: string | null): PasswordProblem | null {
  const kinds = KINDS.filter((k) => k.test(password)).length;
  if ([...password].length < MIN_PASSWORD || kinds < 3) return 'weak';
  const pw = password.toLowerCase();
  const name = (email ?? '').trim().toLowerCase().split('@')[0] ?? '';
  if (name.length >= 3 && pw.includes(name)) return 'emailName';
  if (pw.includes('veoride')) return 'veoride';
  return null;
}
